import React, { useState } from "react";
import "../CSS/DetailPasienTK.css";
import { FaCalendarAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

function DetailPasienTK() {
  const [activeTab, setActiveTab] = useState("dataPasien");
  const navigate = useNavigate();

  const handleEditClick = () => {
    alert("Menuju halaman edit data pasien (dummy)");
  };

  const handleTabClick = (tabName) => {
    setActiveTab(tabName);

    if (tabName === "riwayatTerapi") {
      navigate("/HalamanRiwayatTerapiPasien"); 
    } else if (tabName === "riwayatScreening") {
      navigate("/riwayat-screening"); 
    }
  };

  return (
    <div className="detailpasien-page">
      <div className="main-contentdetailpasien">

        <div className="detailpasien-container">
          <div className="profile-section">
            <div className="profile-avatar">PS</div>
            <div className="profile-info">
              <h3>Nezuko</h3>
              <div className="status-info">
                <span className="status-active">● Status: Aktif</span>
                <span className="risk-low">● Risiko: Rendah</span>
              </div>
            </div>
          </div>

          <div className="tabs">
  <button
    className={activeTab === "dataPasien" ? "tab active" : "tab"}
    onClick={() => handleTabClick("dataPasien")}
  >
    Data Pasien
  </button>
  <button
    className={activeTab === "riwayatTerapi" ? "tab active" : "tab"}
    onClick={() => handleTabClick("riwayatTerapi")}
  >
    Riwayat Terapi
  </button>
  <button
    className={activeTab === "riwayatScreening" ? "tab active" : "tab"}
    onClick={() => handleTabClick("riwayatScreening")}
  >
    Riwayat Screening
  </button>
</div>

         

          {/* Tab Content */}
          {activeTab === "dataPasien" && (
            <div className="data-pasien-form">
              <div className="form-left">
                <label>ID Pasien</label>
                <input type="text" value="0001" readOnly />

                <label>Nama Lengkap</label>
                <input type="text" value="Nezuko" readOnly />

                <label>Nomor Telephone</label>
                <input type="text" value="085231256566" readOnly />

                <label>Tempat Lahir</label>
                <input type="text" value="Magetan" readOnly />

                <label>Tanggal Lahir</label>
                <div className="input-with-icon">
                  <input type="text" value="23-01-1985" readOnly />
                  <FaCalendarAlt className="calendar-icon" />
                </div>

                <label>Umur</label>
                <input type="text" value="30" readOnly />
              </div>

              <div className="form-right">
                <label >Alamat Lengkap</label>
                <textarea class="poppins-textarea"
                  rows="4"
                  value="Desa Buluharjo, Rt.07/Rw.09, Kecamatan Plaosan, Kabupaten Magetan, Jawa Timur"
                  readOnly
                ></textarea>

                <label>Tenaga Kesehatan Penanggung Jawab</label>
                <select>
                  <option>Dr. Muichiro</option>
                </select>

                <label>Alamat Fasilitas Kesehatan</label>
                <select>
                  <option>RSUD Magetan</option>
                </select>

                
                 <label>Status Terapi</label>
                <select>
                  <option>Aktif</option>
                  <option>Selesai</option>
                  <option>Tidak Ada</option>
                </select>

                <button className="edit-btn" onClick={handleEditClick}>
                  Edit Data
                </button>
              </div>
            </div>
          )}

          {activeTab === "riwayatTerapi" && (
            <div className="tab-content">
              <p>Menampilkan riwayat terapi pasien </p>
            </div>
          )}

          {activeTab === "riwayatScreening" && (
            <div className="tab-content">
            
            </div>
          )}
        </div>

        <footer className="footerdetail">© 2025 TibiSmart. All rights reserved.</footer>
      </div>
    </div>
  );
}

export default DetailPasienTK;
